import {
    OBJECT_TYPE_ROW,
    OBJECT_TYPE_SEAT,
    OBJECT_TYPE_SECTOR,
    OBJECT_TYPE_ROUND_TABLE,
    OBJECT_TYPE_RECTANGLE_TABLE, OBJECT_TYPE_GENERAL_ADMISSION,
} from '%paysera_seat_selection/js/seatSelection/config/constants';

function getOrderBy(orderSpec) {
    return Object.keys(orderSpec);
}

function getOrderDirection(orderSpec) {
    return Object.values(orderSpec);
}

function extractSeatsFromRow(row, orderSpec) {
    if (orderSpec !== null) {
        return row.seats.orderBy(['index'], ['asc']).toModelArray();
    }
    return row.seats.toModelArray();
}

function extractSeatsFromModel(model, orderSpec = null) {
    let seats = [];

    if (model.objectType === OBJECT_TYPE_SECTOR) {
        if (orderSpec !== null) {
            seats = seats.concat(
                ...model.rows.orderBy(
                    getOrderBy(orderSpec),
                    getOrderDirection(orderSpec),
                ).toModelArray().map(row => extractSeatsFromRow(row, orderSpec)),
            );
        } else {
            seats = seats.concat(...model.rows.toModelArray().map(row => extractSeatsFromRow(row, null)));
        }
    }
    if (model.objectType === OBJECT_TYPE_ROW) {
        seats = extractSeatsFromRow(model, orderSpec);
    }
    if (model.objectType === OBJECT_TYPE_ROUND_TABLE) {
        seats = extractSeatsFromRow(model, orderSpec);
    }
    if (model.objectType === OBJECT_TYPE_RECTANGLE_TABLE) {
        seats = extractSeatsFromRow(model, orderSpec);
    }
    if (model.objectType === OBJECT_TYPE_SEAT) {
        seats.push(model);
    }

    return seats;
}

function extractSeatingsFromModel(model) {
    const seats = extractSeatsFromModel(model);
    if (model.objectType === OBJECT_TYPE_GENERAL_ADMISSION) {
        seats.push(model);
    }

    return seats;
}

function extractSeatsFromParentOrdered(seat) {
    let items = [];

    if (seat.row !== null) {
        items = seat.row.seats.orderBy(['index'], ['asc']).toModelArray();
    }
    if (seat.roundTable !== null) {
        items = seat.roundTable.seats.orderBy(['index'], ['asc']).toModelArray();
    }
    if (seat.rectangleTable !== null) {
        items = seat.rectangleTable.seats.orderBy(['index'], ['asc']).toModelArray();
    }

    return items;
}

function extractSeatsFromSelection(selection) {
    return [].concat(...selection.map(item => extractSeatsFromModel(item, null)));
}

function extractSeatingsFromSelection(selection) {
    return [].concat(...selection.map(item => extractSeatingsFromModel(item, null)));
}

export {
    extractSeatsFromSelection,
    extractSeatingsFromSelection,
    extractSeatsFromModel,
    extractSeatsFromParentOrdered,
    extractSeatsFromRow,
};
